import { render, staticRenderFns } from "./AddVersion.vue?vue&type=template&id=2f16d4c2&scoped=true"
import script from "./AddVersion.vue?vue&type=script&lang=js"
export * from "./AddVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16d4c2",
  null
  
)

export default component.exports